import styled from '@emotion/styled';
import { AppToolbar, AppToolbarContent } from '@lbcamden/lib-react';
import { Link } from 'react-router';

export const AppToolbarRoot = styled(AppToolbar)`
  ${AppToolbarContent} a {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${({ theme }) => theme.spacing([0, 3])};
    font-weight: 600;
    color: ${({ theme }) => theme.colors.textNegative};
    text-decoration: none;
  }
`;

export const HomeLink = styled(Link)`
  display: flex;
`;
